import _ from 'lodash'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import datasetsOverviewInfoLinkedDatasets from './datasets-overview-info-linked-datasets.hbs'
import icon from 'scoreboard/components/icon'
import unwrapModel from 'scoreboard/components/unwrap-model'
import datasetsOverviewInfoSupportingForms from './datasets-overview-info-supporting-forms.hbs'

/**
 * Same as a generic overview, but with a linked datasets section added.
 */
var DatasetsOverviewInfo = GenericOverviewInfo.extend({

	/** @type {Dataset} */
	model: null,

	render: function() {
		GenericOverviewInfo.prototype.render.apply(this, arguments)
		let linkedDatasets = this.model.get('linkedDatasets')
		if (!_.isEmpty(linkedDatasets)) {
			let sortedDatasets = _.orderBy(linkedDatasets, [dataset => dataset.label.toLowerCase()], ['asc'])
			this.$('.related').before(datasetsOverviewInfoLinkedDatasets())
			let html = ''
			_.each(sortedDatasets, linkedDataset => {
				linkedDataset = unwrapModel(linkedDataset)
				html +=
					`<li class="sp-navigate" href="datasets/${linkedDataset.id}">` +
						'<div class="content-wrapper">' +
							icon('dataset') +
							`<h3>${_.escape(linkedDataset.label)}</h3>` +
						'</div>' +
					`</li>`
			})
			this.$('.linked-datasets.panel .list').html(html)
		}

		let supportingForms = this.model.get('supportingForms')
		if (!_.isEmpty(supportingForms)) {
			this.$('.related').before(datasetsOverviewInfoSupportingForms({forms: supportingForms}))
		}
		return this
	}

})


export default DatasetsOverviewInfo

DatasetsOverviewInfo.__filename__ = 'datasets/overview/datasets-overview-info.js'
